import { render, staticRenderFns } from "./batch-list.vue?vue&type=template&id=40028dde&scoped=true&"
import script from "./batch-list.vue?vue&type=script&lang=js&"
export * from "./batch-list.vue?vue&type=script&lang=js&"
import style0 from "./batch-list.vue?vue&type=style&index=0&id=40028dde&lang=scss&scoped=true&"
import style1 from "./batch-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40028dde",
  null
  
)

export default component.exports